module.exports = __webpack_public_path__ + "static/media/mail-icon.3fdfbd94.svg";